import React from 'react';
import { Toaster } from 'react-hot-toast';
import { CartProvider } from './context/CartContext';
import { PicksProvider } from './context/PicksContext';
import { AnnouncementBanner } from './components/layout/AnnouncementBanner';
import { WaitlistBanner } from './components/layout/WaitlistBanner';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { HeroSection } from './components/sections/HeroSection';
import { CompressionSection } from './components/sections/CompressionSection';
import { BracesSection } from './components/sections/BracesSection';
import { HowItWorksSection } from './components/sections/HowItWorksSection';
import { ContactSection } from './components/sections/ContactSection';
import { CartDrawer } from './components/cart/CartDrawer';
import { PicksDrawer } from './components/picks/PicksDrawer';
import { SharedPicksBanner } from './components/picks/SharedPicksBanner';
import { SharedPicksModal } from './components/picks/SharedPicksModal';
import { SharedPicksResolver } from './components/picks/SharedPicksResolver';
import { TrackOrderModal } from './components/orders/TrackOrderModal';
import { AdminOrdersPage } from './components/admin/AdminOrdersPage';
import { AssistantWidget } from './components/assistant/AssistantWidget';

export default function App() {
  // Hidden staff view: https://site/?admin=1 (auth = X-Admin-Secret on the API)
  if (new URLSearchParams(window.location.search).has('admin')) {
    return <AdminOrdersPage />;
  }

  return (
    <CartProvider>
      <PicksProvider>
      <div className="min-h-screen flex flex-col">
        {/* Sticky navbar */}
        <Navbar />

        {/* Waitlist status banner — below navbar */}
        <WaitlistBanner />

        {/* Announcement banner — below navbar */}
        <AnnouncementBanner />

        {/* Shared picks banner (when ?picks= is in URL) */}
        <SharedPicksBanner />

        {/* Main content */}
        <main className="flex-1">
          <HeroSection />
          <CompressionSection />
          <BracesSection />
          <HowItWorksSection />
          <ContactSection />
        </main>

        <Footer />

        {/* Cart slide-in drawer */}
        <CartDrawer />

        {/* Picks slide-in drawer */}
        <PicksDrawer />

        {/* Shared picks receiver flow */}
        <SharedPicksResolver />
        <SharedPicksModal />

        {/* Track order modal (opens via navbar/footer or ?track= link) */}
        <TrackOrderModal />

        {/* Shopping assistant (renders only if the backend has ANTHROPIC_API_KEY) */}
        <AssistantWidget />

        {/* Toast notifications — top-center so they don't overlap the nav icons */}
        <Toaster
          position="top-center"
          containerStyle={{ top: 80 }}
          toastOptions={{
            duration: 1500,
            style: {
              background: '#fff',
              color: '#1a3a5c',
              border: '1px solid #e5e7eb',
              borderRadius: '12px',
              fontSize: '14px',
              fontWeight: '500',
              boxShadow: '0 10px 25px rgba(26,58,92,0.12)',
            },
          }}
        />
      </div>
      </PicksProvider>
    </CartProvider>
  );
}
